// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2jK-L","balanceDisclaimer":"posDashboard_balanceDisclaimer__K7kbP"};